import { RiskLevel } from "./risk-level";
import { ResultInfo } from "./shared.model";

export class EvaluatorResult {
  name: string;
  level: RiskLevel;
  additionalInfo?: ResultInfo;
  description: string;
  weight: number;

  constructor(name: string, level: RiskLevel, weight: number, description: string, info?: ResultInfo) {
    this.name = name;
    this.level = level;
    this.weight = weight;
    this.description = description;
    this.additionalInfo = info;
  }
}
